/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import i18n from '../i18n';
import {diplomatObjectSchema} from './diplomat-object';

export const JobSettings = diplomatObjectSchema.shape({
   startupDelay: yup.number().positive(i18n.t('Should be positive number')).default(1000),
   numConcurrentJobs: yup.number().positive(i18n.t('Should be positive number')).default(50),
});
export type IJobSettings = yup.InferType<typeof JobSettings>;
